module.exports = __webpack_public_path__ + "img/asset11.697aadab.png";